// extracted by mini-css-extract-plugin
export default {"highlight":"HighlightText_highlight__4EnA2","truncatedText":"HighlightText_truncatedText__5VfHd"};